import PageProtectedLayout from "../../components/Page/PageProtectedLayout";
import HealthCockpit from "./Cockpit/HealthCockpit";
import { useTranslation } from '../../language';


export default function RecommendationsWelcome() {

    const { t } = useTranslation();

return (

    <PageProtectedLayout

      headline={t('page_hl_preventive_health')}
      specify={t('page_sp_recommendations')}
      headlineMb={{ xs: 2, sm: 3 }}
      >

     <HealthCockpit section="recommendations" />

    </PageProtectedLayout>

  );
}
